export default __webpack_public_path__ + "static/media/P2.a8e4186a.svg";